import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: "",
  token: "",
  isLoading: false,
};

const authSlice = createSlice({
  name: "authUser",
  initialState,
  reducers: {
    //for login and only

    loginRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.token = action.payload.data.access_token;
      state.isLoading = false;
    },
    loginFailure: (state) => {
      state.isLoading = false; // Set isLoading to true when  request starts
    },

    loginData: (state, data) => {
      state.user = data.userInfo;
      state.token = data.token;
    },

    // for Register only

    registerRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },
    registerSuccess: (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    },
    registerFailure: (state) => {
      state.isLoading = false; // Set isLoading to true when  request starts
    },

    // for mail verifications

    mailVerificationRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },

    mailVerificationSuccess: (state, action) => {
      state.email = action.payload;
      state.otp = action.payload;
      state.isLoading = false;
    },

    mailVerificationFailure: (state) => {
      state.isLoading = false; // Set isLoading to true when  request starts
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  loginData,
  registerRequest,
  registerSuccess,
  registerFailure,
  mailVerificationRequest,
  mailVerificationSuccess,
  mailVerificationFailure,
} = authSlice.actions;

export default authSlice.reducer;
